module.exports = __webpack_public_path__ + "static/media/sg-lotto-square.6b7c939f.png";